<template>
    <a-card :bordered="false">
      <a-divider orientation="left" style="margin-top: -5px;">
        项目信息
      </a-divider>
      <detail-list>
        <detail-list-item term="报建编号">{{projectInfo.reportCode}}</detail-list-item>
        <detail-list-item term="项目编号">{{projectInfo.projectCode}}</detail-list-item>
        <detail-list-item term="项目名称">{{projectInfo.projectName}}</detail-list-item>
        <detail-list-item term="项目地址">{{projectInfo.address}}</detail-list-item>
        <detail-list-item term="项目行业分类">{{projectInfo.industriesType_dictText}}</detail-list-item>
        <detail-list-item term="项目所在行政区域">{{projectInfo.regionCode_dictText}}</detail-list-item>
        <detail-list-item term="项目法人">{{projectInfo.legalPerson}}</detail-list-item>
        <detail-list-item term="法定代表人">{{projectInfo.legalRepresent}}</detail-list-item>
        <detail-list-item term="项目负责人">{{projectInfo.contactor}}</detail-list-item>
        <detail-list-item term="联系电话">{{projectInfo.contactInformation}}</detail-list-item>
        <!--<detail-list-item term="建设用地规划许可证编号">{{projectInfo.buildplannum}}</detail-list-item>
        <detail-list-item term="建设工程规划许可证编号">{{projectInfo.projectplannum}}</detail-list-item>-->
        <detail-list-item term="资金来源">{{projectInfo.fundSource_dictText}}</detail-list-item>
        <detail-list-item term="投资总额">{{projectInfo.totleInvestment}}万元</detail-list-item>
        <detail-list-item term="是否重点项目">{{projectInfo.ismajor=='1'?'是':'否'}}</detail-list-item>

        <detail-list-item term="工程用途">{{projectInfo.functionNum_dictText}}</detail-list-item>
        <detail-list-item term="建设性质">{{projectInfo.propertyNum_dictText}}</detail-list-item>
        <detail-list-item term="财政资金占比">{{projectInfo.governmentInvestFinance}}</detail-list-item>
        <detail-list-item term="自筹资金占比">{{projectInfo.isStateFund}}</detail-list-item>
        <detail-list-item term="其他资金占比">{{projectInfo.notStateFund}}</detail-list-item>
        <detail-list-item term="建安工程费">{{projectInfo.constructionCost}}万元</detail-list-item>
        <detail-list-item term="发包方式">{{projectInfo.constructContractMode_dictText}}</detail-list-item>
        <detail-list-item term="审批文件名称">{{projectInfo.approvalName}}</detail-list-item>
        <detail-list-item term="审批文号">{{projectInfo.approvalNumber}}</detail-list-item>
        <detail-list-item term="审批单位">{{projectInfo.approvalAuthority}}</detail-list-item>
<!--        <detail-list-item term="项目地址">{{projectInfo.address}}</detail-list-item>-->
        <detail-list-item term="采用代建制">{{projectInfo.isAgentConstruct=='1'?'是':'否'}}</detail-list-item>
        <!--<detail-list-item term="超限项目信息">{{projectInfo.cxxminfo}}</detail-list-item>
        <detail-list-item term="建筑节能信息">{{projectInfo.jzjninfo}}</detail-list-item>-->
      </detail-list>
      <div style="margin-bottom: 20px;"><span style="color:rgba(0, 0, 0, 0.85)">工程规模及内容：</span>{{projectInfo.projectScale}}</div>
      <a-divider orientation="left">
        招标项目信息
      </a-divider>
      <detail-list >
        <detail-list-item term="招标项目分类">{{tenderProjectInfo.tenderProjectClassifyCode_dictText}}</detail-list-item>
        <detail-list-item term="招标项目编号">{{tenderProjectInfo.tenderProjectCode}}</detail-list-item>
        <detail-list-item term="招标项目名称">{{tenderProjectInfo.tenderProjectName}}</detail-list-item>
        <detail-list-item term="招标项目备案编号">{{tenderProjectInfo.tenderRecordCode}}</detail-list-item>
        <detail-list-item term="招标人名称">{{tenderProjectInfo.tendererName}}</detail-list-item>
        <detail-list-item term="招标代理名称">{{tenderProjectInfo.tenderAgencyName}}</detail-list-item>
        <detail-list-item term="招标方式">{{tenderProjectInfo.tenderMode_dictText}}</detail-list-item>
        <detail-list-item term="招标组织形式">{{tenderProjectInfo.tenderOrganizeForm_dictText}}</detail-list-item>
        <detail-list-item term="资格审核方式">{{tenderProjectInfo.approvalMode_dictText}}</detail-list-item>
        <detail-list-item term="代理产生方式">{{tenderProjectInfo.tenderAgencyMode_dictText}}</detail-list-item>
        <detail-list-item term="是否电子标">{{tenderProjectInfo.isElect=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="是否远程异地">{{tenderProjectInfo.isRemoteEvaluation=='1'?'是':'否'}}</detail-list-item>

        <detail-list-item term="是否应急项目">{{tenderProjectInfo.isEmergencyProject?'是':'否'}}</detail-list-item>
        <!--<detail-list-item term="是否园林绿化项目">{{tenderProjectInfo.isLandscaping?'是':'否'}}</detail-list-item>-->
        <detail-list-item term="是否允许使用电子保函">{{tenderProjectInfo.allowElectronicGuarantee?'是':'否'}}</detail-list-item>

        <!--<detail-list-item term="评标办法">{{tenderProjectInfo.bidEvaluationName}}</detail-list-item>
        <detail-list-item term="评标专家人数">{{tenderProjectInfo.expertsNumber}}</detail-list-item>-->
        <detail-list-item term="是否评定分离">{{tenderProjectInfo.isSeparate=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="是否无固定范本">{{tenderProjectInfo.isCustomModel=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="申报责任人">{{tenderProjectInfo.reportDuty}}</detail-list-item>
        <detail-list-item term="代理项目负责人">{{tenderProjectInfo.managerName}}</detail-list-item>
        <detail-list-item term="负责人电话号码">{{tenderProjectInfo.managerTel}}</detail-list-item>
        <detail-list-item term="签收单"><a v-if="tenderProjectInfo && tenderProjectInfo.signReceiptFileId" target="_blank" @click="signReceiptFileDownload">[下载]</a><span v-else>无</span></detail-list-item>
        <detail-list-item term="评标办法">{{tenderProjectInfo.bidEvaluationWay}}</detail-list-item>
        <detail-list-item term="是否依法招标">{{tenderProjectInfo.isToLaw=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="是否借用场地">{{tenderProjectInfo.projectType=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="是否重新招标">{{tenderProjectInfo.isRebid=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="是否国债项目">{{tenderProjectInfo.isNationalDebt=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="中标候选人中标结果公示是否合并">{{tenderProjectInfo.isMergeNotice=='1'?'是':'否'}}</detail-list-item>
        <detail-list-item term="监督机构">{{tenderProjectInfo.tenderMonitor}}</detail-list-item>
        <detail-list-item term="监督机构联系电话">{{tenderProjectInfo.tenderMonitorTel}}</detail-list-item>
        <detail-list-item term="监督机构统一社会信用代码">{{tenderProjectInfo.tenderMonitorCode}}</detail-list-item>
        <div style="margin-bottom: 20px;"><span style="color:rgba(0, 0, 0, 0.85)">监督机构办公地址：</span>{{tenderProjectInfo.tenderMonitorAddress}}</div>

      </detail-list>
      <div style="margin-bottom: 20px;"><span style="color:rgba(0, 0, 0, 0.85)">招标说明：</span>{{tenderProjectInfo.tenderContent}}</div>
      <a-divider v-if="userInfo.roleCode!=='ebid_bidder'" orientation="left" style="margin-top: -5px;">
        已提交的文件
      </a-divider>
      <SubmittedDocuments v-if="userInfo.roleCode!=='ebid_bidder'" ref="submittedDocuments"></SubmittedDocuments>
      <a-divider orientation="left">
        标段信息
      </a-divider>

      <a-table ref="table" size="middle" bordered rowKey="id"
        :columns="columns" :dataSource="sectionInfo" :loading="loading" :pagination="false">
      </a-table>
    </a-card>
</template>

<script>
  import DetailList from '@/components/tools/DetailList'
  import {httpAction, getAction, downloadFile} from '@/api/manage'
  import SubmittedDocuments from "@views/task/modules/SubmittedDocuments.vue";
  const DetailListItem = DetailList.Item

  export default {
    components: {
      SubmittedDocuments,
      DetailList,
      DetailListItem,
    },
    name: "BidProjectInfo",
    data () {
      return {
        bidProjectId : "",
        tenderProjectInfo : {},
        projectInfo: {},
        sectionInfo: [],
        userInfo:{},
        loading: false,
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function(t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '标段编号',
            align: 'left',
            dataIndex: 'bidSectionCode'
          },
          {
            title: '所属标段组',
            align: 'left',
            dataIndex: 'sectionGroup',
          },
          {
            title: '标段名称',
            align: 'left',
            dataIndex: 'bidSectionName'
          },
          {
            title: '合同估算价(万元)',
            align: 'left',
            dataIndex: 'contractReckonPrice'
          },
          {
            title: '工期',
            align: 'center',
            dataIndex: 'limiteTime'
          },
          {
            title: '标段包分类',
            align: 'center',
            dataIndex: 'tenderProjectClassifyName'
          },
          {
            title: '创建时间',
            align: 'center',
            dataIndex: 'createTime'
          }
        ]
      }
    },
    filters: {
      statusFilter(status) {
        const statusMap = {
          'processing': '进行中',
          'success': '完成',
          'failed': '失败'
        }
        return statusMap[status]
      }
    },
    created(){
      let userInfo=this.$store.getters.userInfo;
      this.userInfo=userInfo;
    },
    computed: {
      /*title () {
        return this.$route.meta.title
      }*/
    },
    methods: {
      setBidProjectId(id) {
        //1.根据招标编号ID获取招标项目信息和项目信息
        this.bidProjectId = id;
        getAction("/ebid-ce/tmBidProject/queryById",{id:this.bidProjectId}).then(res=>{
          if(res.success){
            this.tenderProjectInfo = res.result;
            let projectId = this.tenderProjectInfo.projectId;
            console.log("projectId:"+projectId);
            //2.查询项目信息
            getAction("/ebid-ce/tmProject/queryById",{id:projectId}).then(res=>{
              if(res.success){
                this.projectInfo = res.result;
              }else {

              }
            })
          }else {

          }

          //2.根据招标编号ID获取标段包信息
          getAction("/ebid-ce/tmBidSection/queryByBidProjectIdWithGroup",{bidProjectId:this.bidProjectId}).then(res=>{
            if(res.success){
              this.sectionInfo = res.result;
              console.log(this.sectionInfo);
              this.makeSectionGroupData()
            }else {

            }
          })
          this.$refs.submittedDocuments.loadData(id)
        })
      },
      makeSectionGroupData(){
        if (this.sectionInfo.length > 0 && this.sectionInfo[0].isGroup == 1) {
          let superMap = new Map()
          this.sectionInfo.forEach(item => {
            if (item.superId == '0') {
              superMap.set(item.id, item.bidSectionName)
            }
          })
          this.sectionInfo.map(item => {
            if (item.superId != '0') {
              item.sectionGroup = superMap.get(item.superId)
            }
            return item
          })
          this.sectionInfo = this.sectionInfo.filter(t => t.superId != '0')
        }else {
          this.columns.forEach(item=>{if (item.dataIndex === 'sectionGroup'){ item.className = 'tableHidden'}})
        }
      },
      signReceiptFileDownload() {
        getAction("/ebid-ce/file/minioDownload",{id: this.tenderProjectInfo.signReceiptFileId}).then(res => {
          if(res.success) {
            downloadFile(res.result,this.tenderProjectInfo.signReceiptFileUrl.substr(this.tenderProjectInfo.signReceiptFileUrl.lastIndexOf("/")+1));
          }else{
            this.$message.warning(res.message);
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .tableHidden{
    display: none;
  }

</style>